import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.black,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 60
  const h = 60
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30 52.5C42.4264 52.5 52.5 42.4264 52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30C7.5 42.4264 17.5736 52.5 30 52.5Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M27.2461 25.1875H33.2461"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.9461 32.9749L37.4836 20.5624C36.9196 20.0044 36.1582 19.6914 35.3648 19.6914C34.5715 19.6914 33.8101 20.0044 33.2461 20.5624V34.6874"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.2469 34.6874V20.5624C26.6829 20.0044 25.9215 19.6914 25.1281 19.6914C24.3347 19.6914 23.5734 20.0044 23.0094 20.5624L17.5469 32.9749"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2461 39.6875C25.0075 39.6875 27.2461 37.4489 27.2461 34.6875C27.2461 31.9261 25.0075 29.6875 22.2461 29.6875C19.4847 29.6875 17.2461 31.9261 17.2461 34.6875C17.2461 37.4489 19.4847 39.6875 22.2461 39.6875Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2461 39.6875C41.0075 39.6875 43.2461 37.4489 43.2461 34.6875C43.2461 31.9261 41.0075 29.6875 38.2461 29.6875C35.4847 29.6875 33.2461 31.9261 33.2461 34.6875C33.2461 37.4489 35.4847 39.6875 38.2461 39.6875Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgComponent
